import {Component} from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.logException = this.logException.bind(this);
    }

    componentDidMount() {
        // this is needed to catch errors thrown even if rendering succeeded
        window.addEventListener('error', this.logException);
    }

    componentWillUnmount() {
        window.removeEventListener('error', this.logException);
    }

    componentDidCatch(error, info) {
        // this will only catch errors thrown if rendering failed, that's why we have the window event listener
        this.props.clientLogger.logError(error);
        this.props.clientLogger.logError(info.componentStack);
    }

    logException(e) {
        this.props.clientLogger.logException(e.message);
        this.props.clientLogger.logException(e.error.stack);
    }

    render() {
        return this.props.children;
    }
}

export default ErrorBoundary;
